module.exports = __webpack_public_path__ + "src/assets/images/Notifications_RA.png?7827e43e498f4b3312b47bd59d23b4a9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Notifications_RA.png
// module id = 979
// module chunks = 1